import { FormControl } from "@angular/forms";

export interface Organization {
  NombreOrganizacion: string;
  TelefonoOrganizacion: string;
  DireccionOrganizacion: string;
  RTN: null;
  CorreoOrganizacion: null;
}

export interface Notificacion {
  CodNotificacion:         number;
  CodCategoria:            number;
  NombreNotificacion:      string;
  DescripcionNotificacion: string;
  HTML:                    string;
  Imagen:                  null;
  FechaCreacion:           Date;
  Leido:                   boolean;
}
export interface AjustesBasicos {
  FormatoFecha:                 string;
  FormatoHora:                  string;
  TiempoPantalla:               number;
  EnvioCocina:                  boolean;
  ManejoEstadoPedidos:          boolean;
  PermitirImprimirFactura:      boolean;
  ImprimirFacturaOriginalCopia: boolean;
  ManejoFacturacion:            boolean;
  FacturasXCorreo:              boolean;
  FacturasXWhatsApp:            boolean;
  NombreContacto:               string;
  DatoContacto:                 string;
  ManejoPropina:                boolean;
  ValorPropina:                 number;
  AntesImpuesto:                boolean;
  MantenerEncendidaPropina:     boolean;
  ManejoDevoluciones:           boolean;
  PlazoDevoluciones:            number;
  ClienteExonerado:             boolean;
  SeguridadPIN:                 boolean;
  SeguridadBiometrico:          boolean;
  ManejoProductosCompuestos:    boolean;
  ManejoInventario:             boolean;
  ManejoTiposPedido:            boolean;
  ManejoAgregadores:            boolean;
  ImpuestoIncluido:             boolean;
  DescuentosGenerales:          boolean;
  VentaRelampago:               boolean;
  ManejoFormatosVentaRapida:    boolean;
  SolicitarRazonQuitarPropina:  boolean;
  AbreviacionMoneda:            string;
  SimboloMoneda:                string;
  NombreMoneda:                 string;
  QuickView:  boolean;
  ConfiguracionesVentaRapida: ConfiguracionesVentaRapida;
}

export const sortNotificationsByDate = (a: Notificacion, b: Notificacion) => {
  const aDate = new Date(a.FechaCreacion);
  const bDate = new Date(b.FechaCreacion);
  return bDate.getTime() - aDate.getTime();
};

export interface ConfiguracionCotizacion {
  CodConfiguracion: number;
  CodOrganizacion?: number;
  UsarCotizaciones?: boolean;
  NombreOrganizacion: string;
  RTNOrganizacion: string;
  Correo: string;
  NumeroTelefono: string;
  Direccion: string;
  UrlLogo: string;
  TodosDefinenFechaVencimiento?: boolean;
  Descuento?: boolean;
  Envio?: boolean;
  OtroImporte?: boolean;
  NotaParaCliente?: boolean;
  NotaInterna?: boolean;
  AgregarNuevosCampos?: boolean;
  AdjuntarArchivos?: boolean;
}

export interface ConfiguracionCotizacionForm {
  CodConfiguracion: FormControl<number>;
  CodOrganizacion?: FormControl<number>;
  UsarCotizaciones?: FormControl<boolean>;
  NombreOrganizacion: FormControl<string>;
  RTNOrganizacion: FormControl<string>;
  Correo: FormControl<string>;
  NumeroTelefono: FormControl<string>;
  Direccion: FormControl<string>;
  UrlLogo: FormControl<string>;
  TodosDefinenFechaVencimiento?: FormControl<boolean>;
  Descuento?: FormControl<boolean>;
  Envio?: FormControl<boolean>;
  OtroImporte?: FormControl<boolean>;
  NotaParaCliente?: FormControl<boolean>;
  NotaInterna?: FormControl<boolean>;
  AgregarNuevosCampos?: FormControl<boolean>;
  AdjuntarArchivos?: FormControl<boolean>;
}

export interface InfoEmpresaCotizacionForm {
  NombreOrganizacion: FormControl<string>;
  RTNOrganizacion: FormControl<string>;
  Correo: FormControl<string>;
  NumeroTelefono: FormControl<string>;
  Direccion: FormControl<string>;
  UrlLogo: FormControl<string>;
}

export interface ConfiguracionesVentaRapida{
  LimiteDescripcion:number;
}